import {CREATE_TEAM, FETCH_TEAM, FETCH_ALL_TEAMS, DELETE_TEAM} from "../actions/actions-index";
import * as _ from "lodash";

export function team (state = {}, action) {

    switch (action.type) {
        case FETCH_ALL_TEAMS:
            return _.mapKeys(action.payload, 'id');
        case FETCH_TEAM:
            const team = action.payload;
            const newState = { ...state };
            newState[team.id] = team;
            return newState;
        case CREATE_TEAM:
            return state;
        case DELETE_TEAM:
            let deletedState = { ...state };
            delete deletedState[action.payload]
            return deletedState;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/reducers-team.js